module.exports = __webpack_public_path__ + "static/media/resultsGraphicFailed1.20183769.JPG";